import * as React from "react";
import PickersTextField from "./PickersTextField";
import { Calendar } from "./icons";
import { DateTimePicker as MaterialDateTimePicker, DateTimePickerProps as MaterialDateTimePickerProps } from "@mui/x-date-pickers-pro";
import { getDataProps } from "../../shared/utilities";

export interface DateTimePickerProps extends MaterialDateTimePickerProps {
    name?: string;
    error?: boolean;
    helperText?: string;
}

const DateTimePicker: React.FunctionComponent<DateTimePickerProps> = React.forwardRef((props: DateTimePickerProps, ref: any) => {
    const { slots: _slots, error, helperText, ...rest } = props;

    const slots = React.useMemo(() => {
        return {
            openPickerIcon: Calendar,
            textField: (params) => <PickersTextField {...params} size="small" fullWidth error={error} helperText={helperText} />,
            ..._slots,
        };
    }, [_slots, error, helperText])

    return (
        <div className="date-picker-container" {...getDataProps(rest)}>
            <MaterialDateTimePicker
                ref={ref}
                format="yyyy/MM/dd HH:mm"
                ampm={false}
                slots={slots}
                {...rest}
            />
        </div>
    );
});

export default DateTimePicker;